<template>
  <div class="needle-section" ref="sectionRef">
    <div class="needle-container">
      <img :src="require('@/assets/images/needle-left3.png')" class="needle l3" />
      <img :src="require('@/assets/images/needle-left2.png')" class="needle l2" />
      <img :src="require('@/assets/images/needle-left1.png')" class="needle l1" />
      <img :src="require('@/assets/images/needle-right3.png')" class="needle r3" />
      <img :src="require('@/assets/images/needle-right2.png')" class="needle r2" />
      <img :src="require('@/assets/images/needle-right1.png')" class="needle r1" />
      <img :src="require('@/assets/images/needle-center.png')" class="needle center" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const sectionRef = ref(null)

onMounted(() => {
  gsap.timeline({
    scrollTrigger: {
      trigger: sectionRef.value,
      start: () => `top ${window.innerHeight * 0.45}px`, // 進入視窗下 45% 就播
      toggleActions: "play none none none", // 只播一次
      once: true, // 進入畫面只播一次
      markers: false
    }
  })
  .fromTo('.l1', { rotation: 0 }, { rotation: -20, duration: 1 })
  .fromTo('.l2', { rotation: 0 }, { rotation: -40, duration: 1 }, '<')
  .fromTo('.l3', { rotation: 0 }, { rotation: -60, duration: 1 }, '<')
  .fromTo('.r1', { rotation: 0 }, { rotation: 20, duration: 1 }, '<')
  .fromTo('.r2', { rotation: 0 }, { rotation: 40, duration: 1 }, '<')
  .fromTo('.r3', { rotation: 0 }, { rotation: 60, duration: 1 }, '<')
})
</script>

<style scoped>
.needle-section {
  padding: 0 60px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* ✅ 關鍵！裁切超出內容 */
}

.needle-container {
  position: relative;
  width: 600px;      /* ✅ 放大容器寬度 */
  height: 600px;     /* ✅ 放大容器高度 */
  transform: scale(1.6); /* ✅ 整體放大視覺效果 */
  transform-origin: bottom center; /* ✅ 從底部放大更自然 */
}

.needle {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 150px;
  transform: translateX(-50%);
  transform-origin: bottom center;
}

.center {
  z-index: 2;
}

/* 響應式調整 */
@media (max-width: 992px) {
  .needle-container {
    transform: scale(1.1);
  }
}

@media (max-width: 768px) {
  .needle-section {
    padding: 0 20px;
  }
  .needle-container {
    height: 400px;
    transform: scale(0.9);
  }
}

@media (max-width: 576px) {
  .needle-section {
    padding: 0;
  }
  .needle-container {
    height: 250px;
    transform: scale(0.7);
  }
}
</style>
